
import { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useLanguage } from '@/contexts/LanguageContext';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import SolutionsSection from '@/components/SolutionsSection';

const Solutions = () => {
  const { language } = useLanguage();
  
  const pageTitle = language === 'en' ? 'Solutions | Attaboy Intelligence' : 'Solutions | Attaboy Intelligence Artificielle';
  const pageDescription = language === 'en' 
    ? 'Tailored AI solutions for various industries and use cases to drive growth and efficiency.' 
    : 'Solutions d\'IA personnalisées pour diverses industries et cas d\'utilisation pour stimuler la croissance et l\'efficacité.';

  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={pageDescription} />
        <meta property="og:title" content={pageTitle} />
        <meta property="og:description" content={pageDescription} />
      </Helmet>
      
      <div className="flex flex-col min-h-screen">
        <Navbar />
        <main className="pt-24">
          <div className="container mx-auto px-4 py-12">
            <h1 className="text-4xl md:text-5xl font-bold mb-6 font-poppins">
              {language === 'en' ? 'Our Solutions' : 'Nos Solutions'}
            </h1>
          </div>
          <SolutionsSection />
        </main>
        <Footer />
      </div>
    </>
  );
};

export default Solutions;
